import { Component, TemplateRef, inject } from '@angular/core';

import { ToastService } from '../../services/toast.service';
import { NgForOf, NgIf, NgTemplateOutlet } from '@angular/common';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'app-toasts',
	standalone: true,
	imports: [NgbToastModule, NgForOf, NgIf, NgTemplateOutlet],
template: `
    <ng-container *ngFor="let toast of toastService.toasts">
        <ngb-toast
            [class]="toast.classname"
            header="{{toast.error ? toast.error : toast.header ? toast.header : 'Avviso di successo'}}"
            [autohide]="true"
            [delay]="toast.delay || 5000"
            (hidden)="toastService.remove(toast)"
            [style.background-color]="toast.error ? '#ff0000 !important' : toast.type == 'warning' ? '#FFC500 !important' : '#3ea84b !important'"
            > {{ toast.message }}
                <ng-template [ngTemplateOutlet]="isTemplateRef(toast.template) ? toast.template : null">
                <ng-container *ngIf="!isTemplateRef(toast.template)">
                    {{ toast.template }}
                </ng-container>
                </ng-template>
        </ngb-toast>
    </ng-container>

`,
	host: { class: 'toast-container position-fixed top-0 end-0 p-3', style: 'z-index: 9999' },
})
export class ToastsContainer {

    constructor(public toastService: ToastService) {}

    isTemplateRef(value: any): value is TemplateRef<any> {
        return value instanceof TemplateRef;
    }

}
